// src/components/LoginPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const navigate = useNavigate();

  // State to hold the user's input
  const [email, setEmail] = useState('admin@gmail.com');
  const [password, setPassword] = useState('admin');
  
  // State to hold any login error messages
  const [error, setError] = useState('');

  // This function handles the validation and redirect
  const handleLogin = () => {
    // 1. Clear any previous errors
    setError('');

    // 2. Hardcoded validation check
    if (email === 'admin@gmail.com' && password === 'admin') {
      // 3. If credentials are correct, navigate to the dashboard
      console.log("Login successful! Redirecting...");
      navigate('/dashboard');
    } else {
      // 4. If credentials are incorrect, set an error message
      setError('Invalid email or password. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="p-8 bg-white rounded-xl shadow-lg text-center max-w-sm w-full">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Admin Panel</h1>
        <p className="text-gray-600 mb-8">Please log in to continue.</p>
        
        <div className="space-y-4 mb-6">
          <input 
            type="email" 
            placeholder="Email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)} // Update email state on change
            className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
          />
          <input 
            type="password" 
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)} // Update password state on change
            className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Conditionally render the error message if it exists */}
        {error && (
          <div className="mb-4 text-red-500 text-sm">
            {error}
          </div>
        )}

        <button
          onClick={handleLogin}
          className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 transition-colors"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
